var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdParty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 4.66589V6.99902M7 9.33215H7.00729M12.8338 7.58257C12.8338 10.499 10.2815 11.9572 7.24794 12.8029C7.08908 12.846 6.91653 12.8439 6.75936 12.7971C3.71849 11.9572 1.1662 10.499 1.1662 7.58257V3.49959C1.1662 3.3449 1.24303 3.19654 1.37979 3.08715C1.51654 2.97776 1.70202 2.91631 1.89543 2.91631C3.35387 2.91631 5.17694 2.21637 6.44579 1.32978C6.60028 1.22421 6.7968 1.1662 7 1.1662C7.2032 1.1662 7.39972 1.22421 7.55421 1.32978C8.83035 2.2222 10.6461 2.91631 12.1046 2.91631C12.298 2.91631 12.4835 2.97776 12.6202 3.08715C12.757 3.19654 12.8338 3.3449 12.8338 3.49959V7.58257Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdParty);
export default __webpack_public_path__ + "static/media/ThirdParty.3800a2f708262a2d8ec26839b6ae0e24.svg";
export { ForwardRef as ReactComponent };